export default "__VITE_ASSET__DhwJdxlG__"